import React, { useState } from 'react';
import { clarityEvent } from '../utils/clarity';
import './AuthForm.css'; // Ensure this CSS file is imported

const SsoLogin = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const handleSsoLogin = (e) => {
        e.preventDefault();
        if (!email.includes('@')) {
            setError('Please enter a valid email address.');
            return;
        }

        const domain = email.split('@')[1];

        // Redirect the user to the auth-service's OIDC entry point.
        // Spring Security will handle the rest from here.
        clarityEvent('sso_login_attempted');
        window.location.href = `http://localhost:8081/oauth2/authorization/${domain}`;
    };

    return (
     <div className="auth-form-panel">
        <div className="auth-form-container">
            <h2>Login with Corporate ID</h2>
            <form onSubmit={handleSsoLogin}>
                <div className="input-group">
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your corporate email"
                        required
                    />
                </div>
                <button type="submit" className="auth-button-primary">Continue</button>
                {error && <p className="error-message">{error}</p>}
            </form>
        </div>
     </div>
    );
};

export default SsoLogin;